import styled from "styled-components";

export const EventListHorizontalWrapper = styled.div`
  .ktSwiperSlide {
    width: fit-content;
    height: fit-content;
  }
`;
